import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { cancel } from "../../assets/icons";
import { ActionType } from "../../store/product/product_depatu/actions";
import { useQueries } from "../../utils/query_searchParams/QuerySearchParams";

interface INewChipProps {
  dispatchContext: any;
  stateContext: any;
  queryParams?: any;
}

const NewChip: React.FC<INewChipProps> = ({
  dispatchContext,
  stateContext,
  queryParams,
}) => {
  const query = useQueries(useLocation);
  const { search, pathname } = useLocation();
  const history = useHistory();
  const { chip, filter } = stateContext;

  const handleChipByKey = (el: any) => {
    const new_data = chip.filter((item: any) => item !== el);
    dispatchContext({
      type: ActionType.HandleChip,
      payload: new_data,
    });
    const new_filter = { ...filter, [el]: "" };
    dispatchContext({
      type: ActionType.HandleChip,
      payload: new_filter,
    });
    for (const key in queryParams) {
      let new_search;
      let value: any = query.get(queryParams[key].real_name);
      if (value !== null && queryParams[key].show_name === el) {
        new_search = search.replace(
          `&&${queryParams[+key].real_name}=${value.split(" ").join("%20")}`,
          ""
        );
        let filter: any = query.get("filter");
        let new_search_next = new_search.replace(filter, "false");
        history.push({ pathname, search: new_search_next });
      }
    }
  };

  return (
    <div>
      {chip && (
        <div className="md:flex hidden">
          {chip.map((el: any) => (
            <div className="inline-flex items-center rounded mr-3 bg-white border-2 border-stroke p-1 mt-1">
              <span className="px-2 text-sm">{el.split("_").join(" ")}</span>
              <button type="button" className="h-6 w-6 p-1 focus:outline-none">
                <img
                  onClick={() => handleChipByKey(el)}
                  src={cancel}
                  alt="cancel"
                  className="cursor-pointer w-2.5"
                />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NewChip;
